import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { getGameSlotStatement } from '../../../api/ContributionsAPI';
import AppBreadCrumb from '../../../components/common/AppBreadCrumb';

const ContributionStatementPage = () => {
    const { slotId } = useParams();
    const [statement, setStatement] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getGameSlotStatement(slotId, (data) => {
            setIsLoading(false);
            if (data.slot_details) {
                setStatement(data);
            } else {
                Swal.fire('Error!', 'Could not fetch statement data.', 'error');
            }
        });
    }, [slotId]);

    if (isLoading) {
        return <div className="text-center p-5"><div className="spinner-border"></div></div>;
    }

    if (!statement) {
        return <div className="text-center p-5">Statement data could not be loaded.</div>;
    }

    const { slot_details, summary, line_items } = statement;

    return (
        <>
            {/* This style block hides the app's chrome when printing */}
            <style type="text/css" media="print">
                {`
                    @page { size: auto; margin: 0.5in; }
                    body { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
                    #app-sidebar, #app-header, .breadcrumb-container, .print-button-container {
                        display: none !important;
                    }
                    main {
                        padding: 0 !important;
                        margin: 0 !important;
                    }
                `}
            </style>
            <main>
                <div className="container-fluid">
                    <div className="breadcrumb-container">
                        <AppBreadCrumb title={`Statement for ${slot_details.date}`} />
                    </div>
                    
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <div>
                                <h4 className="mb-0">Game Slot Statement</h4>
                                <strong>{slot_details.venue}</strong>
                            </div>
                            <div className="text-end">
                                <div><strong>Date:</strong> {slot_details.date}</div>
                                <div><strong>Time:</strong> {slot_details.time}</div>
                            </div>
                        </div>
                        <div className="card-body">
                              <div className="row mt-4">
                                <div className="col-md-6 offset-md-6">
                                    <h5>Summary</h5>
                                    <table className="table">
                                        <tbody>
                                            <tr>
                                                <td>Slot Cost:</td>
                                                <td className="text-end">₹{slot_details.total_cost}</td>
                                            </tr>
                                            <tr>
                                                <td>Total Heads:</td>
                                                <td className="text-end">{summary.total_heads}</td>
                                            </tr>
                                            {/* <tr>
                                                <td>Base Share/Head:</td>
                                                <td className="text-end">₹{parseFloat(summary.base_share_per_head).toFixed(2)}</td>
                                            </tr> */}
                                           {/* --- START: UPDATED ROW --- */}
                                            {/* Show effective share only if different from base share */}
                                            {summary.effective_share_per_head.toFixed(2) !== summary.base_share_per_head.toFixed(2) && (
                                                <tr>
                                                    <td>Effective Share/Head (Non-Discounted):</td>
                                                    <td className="text-end">₹{parseFloat(summary.effective_share_per_head).toFixed(2)}</td>
                                                </tr>
                                            )}
                                            {/* --- END: UPDATED ROW --- */}

                                            <tr>
                                                <td>Total Collected:</td>
                                                <td className="text-end">₹{parseFloat(summary.total_collected).toFixed(2)}</td>
                                            </tr>
                                            <tr className="table-secondary">
                                                <td className="fw-bold">Difference:</td>
                                                <td className="text-end fw-bold">₹{parseFloat(summary.difference).toFixed(2)}</td>
                                            </tr>
                                        
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <h5>Contributions Breakdown</h5>
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Player Name</th>
                                            <th>Details</th>
                                            <th>Paid By</th>
                                            <th className="text-end">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {line_items.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.player_name}</td>
                                                <td>{item.details}</td>
                                                <td>{item.paid_by}</td>
                                                <td className="text-end">₹{parseFloat(item.amount).toFixed(2)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            
                          
                        </div>
                        <div className="card-footer text-end print-button-container">
                            <button className="btn btn-primary" onClick={() => window.print()}>
                                <i className="bi bi-printer me-2"></i>Print Statement
                            </button>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default ContributionStatementPage;